import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Uniform() { 
  useEffect(() => {
    document.title = 'Uniform -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Academics</li>
                <li>Uniform</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Uniform</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
               <div className="table-responsive">
                    <table className="table maintable">
                        <thead>
                            <tr>
                                <th>GIRLS</th>
                                <th>BOYS</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="tablebg">
                                <td colspan="2">Monday to Friday </td>
                            </tr>
                            <tr className="tablebg">
                               <td colspan="2">Summer </td>
                            </tr>
                            <tr>
                                <td><p>Grey skirt* and white shirt* (half sleeved) with School monogram <br/>School tie, belt, black tights, socks and black shoes with buckles.</p></td>
                                <td><p>Grey Half Pants*/Trousers* (For Classes I to III) <br/> Grey Full Pants* (For Classes IV to XII) <br/>White Shirt (Half Sleeved) with school monogram  <br/> School Tie, Belt, Socks and Black Shoes with Laces.</p></td>
                            </tr>
                            <tr className="tablebg">
                               <td colspan="2">Winter </td>
                             </tr>
                             <tr>
                                <td><p>Grey skirt* and white shirt* (full sleeved) with School monogram <br/>School tie, belt, black tights, socks, black shoes with buckle, maroon blazer with School monogram with maroon sweater (half sleeved)</p></td>
                             <td><p>Grey Full pants* (For classes I to XII) White shirt (Full Sleeved) with school monogram School tie, belt, socks and black shoes with laces. Maroon Blazer with school monogram & Sweater (Half Sleeved). Maroon Blazer with school monogram.</p></td>
                                </tr>
                        </tbody>
                        </table>
                </div>
                <p><strong>WEDNESDAY :</strong> House uniform**.</p>
                <p><strong>SATURDAY :</strong> Yoga Dress. Grey long sleeved sweat shirt and lowers with the school's name printed at the back to be worn every Saturday for the full day. (Compulsory for all the students)</p>
                <p>It is compulsory for every student to wear their house uniform on all Wednesdays and yoga dress on all the Saturdays.</p>
                <p>Wearing of Identity card is mandatory on all the working days.</p>
                <p><strong>*Shade for trousers/skirts:</strong> Brookbond of Dharamvir Suiting &amp; Shirting</p>
                <p><strong>**Shade for check skrits on Wednesdays :</strong> Green Multi Check by Dharamvir Suiting &amp; Shirting Shade No. 465</p>
                <p>Shirts, Blazers and House T-shirts must have the school monogram.</p>
                <p><strong>Note :</strong></p>
                <p>Parents must ensure that their wards come to school in proper uniform daily.</p>
                <p>School uniform should be used only for attending school and should not be used for any other purpose. Students found in school uniform outside the school campus during or after school hours will face disciplinary action.</p>
                <p>Students of class V and below are allowed to wear a decent dress on their birthdays.</p>
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  ); 
}

export default Uniform;
